define('controller/campaign-manager/campaign.manager.controller',['require','exports','module','fukit','model/campaign-manager.model','model/reminder-frequency.model','backbone.radio','underscore','view/campaign-manager/campaign-manager.page.view','fukit'],function(require, exports, module) {
  // prettier-ignore
  var BaseController          = require('fukit').BaseController,
      CampaignManagerModel    = require('model/campaign-manager.model'),
      ReminderFrequencyModel  = require('model/reminder-frequency.model'),
      Radio                   = require('backbone.radio'),
      _                       = require('underscore'),
      CampaignManagerPageView = require('view/campaign-manager/campaign-manager.page.view'),
      ROLES                   = require('fukit').Roles;

  var  coiModel;
  var  productNewCoiUiValue = false;
  const enabledProductCollection =   Radio.request(
      'AppKit.resourceService',
      'resource',
      'enabledProductCollection'
  );

  if (!_.isUndefined(enabledProductCollection)) {
    coiModel = enabledProductCollection.findWhere({name: 'COI', active: true});
    const dataModel = coiModel.collection.models;
    const filteredDataArray = dataModel.filter(function (item) {
      return item.attributes.name === "COI" && item.attributes.active === true;
    });
    productNewCoiUiValue = filteredDataArray[0].attributes.productNewCoiUi;
  }

  if(productNewCoiUiValue){
    localStorage.setItem("productNewCoiUiValue", productNewCoiUiValue.toString());
    location.assign(location.origin + '/coi-react/settings/campaignManager');
  }

  var CampaignManagerController = BaseController.extend({
    radioRequests: {
      'controllers CampaignManagerController': '@constructor',
    },

    pageView: CampaignManagerPageView,

    stateConfiguration: {
      defaults: {
        roles: ROLES.GLOBALACCESSROLES,
      },
    },

    resources: {
      CampaignPeriodCollection: {
        fetchOnStart: true,
        collection: ReminderFrequencyModel.Collection,
        filters: [
          {
            field: 'reminderTypeId',
            value: '0',
          },
        ],
      },
      FinalizedCollection: {
        fetchOnStart: true,
        collection: ReminderFrequencyModel.Collection,
        filters: [
          {
            field: 'reminderTypeId',
            value: '1',
          },
        ],
      },
      campaignManagerModel: {
        fetchOnStart: true,
        fetchWhenNew: true,
        model: CampaignManagerModel,
      },
    },

    initialize: function() {
      BaseController.prototype.initialize.apply(this, arguments);

      this.listenTo(this.getResource('CampaignPeriodCollection'), 'sync', function() {
        var campaignManagerModel = this.getResource('campaignManagerModel');
        var defaultCampaignPeriodModel = this.getResource('CampaignPeriodCollection').findWhere({
          defaultId: 'default0',
        });

        if (campaignManagerModel.get('reminder_frequency') === null) {
          campaignManagerModel.set('reminder_frequency', defaultCampaignPeriodModel);
          campaignManagerModel.resetUnsavedChanges();
        }
      });

      this.listenTo(this.getResource('FinalizedCollection'), 'sync', function() {
        var campaignManagerModel = this.getResource('campaignManagerModel');
        var defaultFinalizedModel = this.getResource('FinalizedCollection').findWhere({
          defaultId: 'default2',
        });

        var doReset = false;

        if (campaignManagerModel.get('reminder_frequency_final_period_of_campaign') === null) {
          campaignManagerModel.set('reminder_frequency_final_period_of_campaign', defaultFinalizedModel);
          doReset = true;
        }

        if (campaignManagerModel.get('reminder_frequency_past_due') === null) {
          campaignManagerModel.set('reminder_frequency_past_due', defaultFinalizedModel);
          doReset = true;
        }

        if (doReset) {
          campaignManagerModel.resetUnsavedChanges();
        }
      });
    },
  });

  module.exports = CampaignManagerController;
});

